export default __webpack_public_path__ + "./images/tk.8d94b295.png";